import React from 'react';
import PredictPatientList from './PredictPatientList';

/**
 * All Patients View - shows all discharge patients
 */
const PredictAllPatients: React.FC = () => {
  return <PredictPatientList ownershipFilter="ALL" />;
};

export default PredictAllPatients;
